/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoyaltyPointsPage.css';

interface LoyaltyTransaction {
  id: string;
  type: 'earned' | 'redeemed';
  amount: number;
  description: string;
  date: string;
}

const LoyaltyPointsPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [points, setPoints] = useState(0);
  const [transactions, setTransactions] = useState<LoyaltyTransaction[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadLoyaltyData();
  }, [user]);

  const loadLoyaltyData = async () => {
    try {
      setIsLoading(true);
      // Get points from user data or localStorage
      const userPoints = (user as any)?.loyalty_points ?? (user as any)?.points ?? 0;
      setPoints(userPoints);
      
      // Load transaction history
      const savedTransactions = localStorage.getItem('loyalty_transactions');
      if (savedTransactions) {
        setTransactions(JSON.parse(savedTransactions));
      } else {
        // Mock transactions
        setTransactions([
          {
            id: '1',
            type: 'earned',
            amount: 50,
            description: 'Order #12345',
            date: new Date().toISOString()
          }
        ]);
      }
    } catch (error) {
      console.error('Error loading loyalty data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="loyalty-points-page">
      <div className="loyalty-body-container">
        <div className="loyalty-header">
          <button className="back-btn" onClick={() => navigate('/app')}>
            ← Back to Dashboard
          </button>
          <h1>⭐ Loyalty Points</h1>
        </div>

        {isLoading ? (
          <div className="loading-state">Loading...</div>
        ) : (
          <>
            {/* Points Summary Card */}
            <div className="points-summary-card">
            <div className="points-icon">⭐</div>
            <div className="points-amount">{points}</div>
            <div className="points-label">Available Points</div>
            <div className="points-value">
              ₹{Math.floor(points / 10)} worth of rewards
            </div>
          </div>

          {/* How It Works */}
          <div className="how-it-works">
            <h2>How It Works</h2>
            <div className="steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h3>Shop & Earn</h3>
                  <p>Earn 1 point for every ₹10 spent</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h3>Redeem Points</h3>
                  <p>Use points to get discounts on orders</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h3>Get Rewards</h3>
                  <p>10 points = ₹1 discount</p>
                </div>
              </div>
            </div>
          </div>

          {/* Transaction History */}
          <div className="transaction-history">
            <h2>Transaction History</h2>
            {transactions.length === 0 ? (
              <div className="no-transactions">
                <p>No transactions yet</p>
                <button className="shop-btn" onClick={() => navigate('/app')}>
                  Start Shopping
                </button>
              </div>
            ) : (
              <div className="transactions-list">
                {transactions.map(transaction => (
                  <div key={transaction.id} className="transaction-item">
                    <div className="transaction-icon">
                      {transaction.type === 'earned' ? '➕' : '➖'}
                    </div>
                    <div className="transaction-details">
                      <div className="transaction-description">{transaction.description}</div>
                      <div className="transaction-date">
                        {new Date(transaction.date).toLocaleDateString()}
                      </div>
                    </div>
                    <div className={`transaction-amount ${transaction.type}`}>
                      {transaction.type === 'earned' ? '+' : '-'}{transaction.amount} pts
                    </div>
                  </div>
                ))}
              </div>
            )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoyaltyPointsPage;









